// 個人中心翻譯

export const personalCenter = {
    title: 'Personal Center',
    subtitle: 'Manage your account, credits, invitations, and orders',
    myCredits: 'My Credits',
    myInvites: 'My Invites',
    myOrders: 'My Orders',
    mySubscriptionsTab: 'My Subscriptions',
    myProfile: {
      title: 'My Profile',
      description: 'Manage your personal information and avatar',
      avatarSettings: 'Avatar Settings',
      basicInformation: 'Basic Information',
      loadingProfile: 'Loading profile...',
      loadingFailed: 'Loading Failed',
      retry: 'Retry',
      uploading: 'Uploading...',
      clickToUpload: 'Click to Upload',
      cancel: 'Cancel',
      cancelUpload: 'Cancel upload',
      supportedFormats: 'Supports JPG, JPEG, PNG, GIF, WEBP formats',
      fileSizeLimit: 'File size should not exceed 5MB',
      uploadSuccess: 'Avatar changed successfully'
    },
    userInfo: {
      unknown: 'Unknown',
      googleAccount: 'Google Account',
      emailRegistration: 'Email Registration',
      unknownMethod: 'Unknown Method',
      verified: 'Verified',
      unverified: 'Unverified',
      emailAddress: 'Email Address',
      registrationMethod: 'Registration Method',
      registrationDate: 'Registration Date'
    },
    mySubscriptions: {
      title: 'My Subscriptions',
      description: 'Manage your subscription plans and billing',
      loading: 'Loading subscriptions...',
      retry: 'Retry',
      noSubscriptions: 'No Active Subscriptions',
      noSubscriptionsDesc: 'You don\'t have any active subscriptions. Browse our plans to get started.',
      browsePlans: 'Browse Plans',
      price: 'Price',
      startDate: 'Start Date',
      nextBilling: 'Next Billing',
      endDate: 'End Date',
      cancelSubscription: 'Cancel Subscription',
      manageOnPayPal: 'Manage on PayPal',
      manageOnStripe: 'Manage on Stripe',
      confirmCancel: 'Are you sure you want to cancel this subscription? This action cannot be undone.',
      cancelSuccess: 'Subscription cancelled successfully',
      cancelError: 'Failed to cancel subscription. Please try again.',
      status: {
        active: 'Active',
        cancelled: 'Cancelled',
        suspended: 'Suspended',
        expired: 'Expired'
      }
    }
  };
